var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('summary-filter',{on:{"submit":_vm.filterSubmit}}),_vm._v(" "),_c('div',{staticClass:"card mt-3 pt-4"},[_c('div',{staticClass:"container-fluid"},[_c('summary-content')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }